import toast from "react-hot-toast";
import * as api from "../Api";
import { errorMessage, loadFailed } from "../utils/errorMessage";

// create a  new asset
export const getRevaluedAsset = () => async (dispatch) => {
  try {
    const { data } = await api.getRevaluedAsset();
    dispatch({ type: "FETCH_ALL_REVALUE_ASSET", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};

export const revalueAsset = (postData, id) => async (dispatch) => {
  const savingId = toast.loading("Revaluing asset...");
  try {
    const { data } = await api.revaluateAsset(postData, id);
    dispatch({ type: "REVALUATE_ASSET", payload: data });
    toast.remove(savingId);
    toast.success("Asset revalued");
    return true;
  } catch (error) {
    toast.remove(savingId);
    toast.error(errorMessage(error, "Failed to revalue asset"));
    return false;
  }
};
